export default "__VITE_PUBLIC_ASSET__f3e136b0__"